import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
const imageAltTexts = {
    bulb: 'notification',
    close: 'dismiss',
    reverse: '',
    decoration: '',
    trash: 'delete',
    arrow: 'opens in a new tab',
    empty: '',
};
export const Image = ({ src, alt, altTextKey, textMsg, width, onClick, cssClass, transform, }) => {
    const { t } = useTranslation();
    return (_jsxs(Box, { onClick: onClick, children: [_jsx(Box, { p: 1, display: 'flex', children: _jsx("img", { src: `${process.env.BASE_URL}${src}`, alt: altTextKey ? imageAltTexts[altTextKey] : alt, width: `${width}px`, style: transform ? { transform: `translate(${transform[0]}px, ${transform[1]}px)` } : {} }) }), textMsg && (_jsx(Box, { mt: 1, children: _jsx(Typography, { variant: 'subtitle1', dangerouslySetInnerHTML: { __html: t(textMsg) }, sx: cssClass }) }))] }));
};
